import { render, staticRenderFns } from "./ActionReasignar.vue?vue&type=template&id=2a1ad1a6&lang=pug"
import script from "./ActionReasignar.vue?vue&type=script&lang=js"
export * from "./ActionReasignar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports